import { render, staticRenderFns } from "./ContactsListActionBtns.vue?vue&type=template&id=c330226e&scoped=true&"
import script from "./ContactsListActionBtns.vue?vue&type=script&lang=js&"
export * from "./ContactsListActionBtns.vue?vue&type=script&lang=js&"
import style0 from "./ContactsListActionBtns.vue?vue&type=style&index=0&id=c330226e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c330226e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
